import { debugLog } from "../../debug-log";

export function ut(event: string, data: Record<string, any> = {}) {
  // Fire-and-forget Umami tracking – never let analytics impact app stability
  try {
    // `track` may be async, but we do not await or depend on its result
    window.umami?.track(event, data);
  } catch (error) {
    debugLog('ut', 'Error tracking Umami event:', error);
    // Silently ignore any Umami errors (network issues, script not loaded, etc.)
  }
}
